import { REPLACE_ALL_STATE } from "./actionTypes";
import mainQuery from "./mainQueryReducer";
import model from "./modelReducer";
import lookupData from "./lookupDataReducer";
import userInteraction from "./userInteractionReducer";

export default (state, action) => {
  switch (action.type) {
    case REPLACE_ALL_STATE:
      return action.newState;
    default: {
      if (process.env.REACT_APP_APP_ENV !== "prod") {
        console.debug(`${action.type} - received`, action);
      }
      const newState = {
        ...state,
        mainQuery: mainQuery(state.mainQuery, action),
        model: model(state.model, action),
        lookupData: lookupData(state.lookupData, action),
        userInteraction: userInteraction(state.userInteraction, action),
      };

      if (process.env.REACT_APP_APP_ENV !== "prod") {
        console.debug(`${action.type} - complete`, {
          state: newState,
        });
      }
      return newState;
    }
  }
};
